/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/**
 * 数科-臻有钱首页-天降红包弹窗 - 通过营销系统接入 https://fat-market-admin.hellobike.cn/#/newActivity/index
 * 接入文档： https://hellobike.yuque.com/gzxsb9/iank77/ao16ve
 */
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import 'TianJiangWebComponent/lib/tianjiang';
import store, { updateModuleState } from '@/store';
import platform from '@/shared/utils/platform';
import { env } from '@/constant';
import { ubtSendError } from '@/shared/utils/ubt';
import { changeTabbarMaskStatus } from '@/api/native/container';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';

const { UBT } = (window as any).TianQi;

@Component
export default class RedPacket extends Vue {
  @Prop({ default: 0 })
  private visit!: number

  private department ='finance'; // 数科金融

  private scene = 2; // 天降红包

  // 获取平台token
  private get originToken() {
    return store.state.base.originUserInfo.token;
  }

  private get cityInfo() {
    const { cityInfo } = store.state.base;
    return {
      adCode: (cityInfo as NativeModel.CityInfo).adCode
      || (cityInfo as NativeModel.AliCityInfo).cityAdcode
      || '',
      cityCode: cityInfo.cityCode || '',
    };
  }

  private handleActivity(data: {detail: {value: boolean}}): void {
    /** 天降红包优先级最高，如有天降，屏蔽其他互斥弹框 */
    if (data.detail.value === false) {
      updateModuleState('base', {
        existTianjiang: false,
      });
    } else {
      this.fixTianjiangFullScreen();
      /** 天降红包弹窗存在时，显示tabbar 遮罩 */
      changeTabbarMaskStatus({
        show: true,
        duration: 100,
        opacity: 0.6,
        tabId: getTabIdByPath(),
      });
    }
  }

  private closeMarketPocket() {
    /** 隐藏遮罩 */
    changeTabbarMaskStatus({
      show: false,
      duration: 100,
      tabId: getTabIdByPath(),
    });
  }

  // 红包组件设置Ubt埋点
  private setUbtInstance() {
    const customPreview = this.$refs.tianjiangRef as any;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, no-unused-expressions
    customPreview.setUbtInstance && customPreview.setUbtInstance(UBT);
  }

  /** 修复天降红包被 沉浸导航栏盖住：因为弹窗是shadow元素，无法通过外层class设置样式 */
  private fixTianjiangFullScreen() {
    try {
      /** handleActivity触发时，还未渲染tianjiang元素 */
      setTimeout(() => {
        const $target = (this.$refs.tianjiangRef as HTMLElement)?.shadowRoot?.querySelector('#market_tianjiang_dialog');

        if ($target) {
          ($target as HTMLElement).style.zIndex = '9999';
        }
      });
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  private mounted() {
    /* 钉钉不投放天降红包
      如果要投放需注意 token 取值问题
     */
    if (platform.isDingTalk || platform.isWechatMini) {
      updateModuleState('base', {
        existTianjiang: false,
      });
    } else {
      this.setUbtInstance();
    }
  }

  private render() {
    return (
      (platform.isDingTalk || platform.isWechatMini) ? null : <tian-jiang-market
        ref={'tianjiangRef'}
        onHandleActivity={this.handleActivity.bind(this)}
        onCloseMarketPocket={this.closeMarketPocket.bind(this)}
        adCode={this.cityInfo.adCode}
        cityCode={this.cityInfo.cityCode}
        env={env}
        token={this.originToken}
        department={this.department}
        scene={this.scene}
        visit={this.visit} />
    );
  }
}
